import { TextField, type TextFieldProps } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AutoCompleteSelector } from "../../../../generic/components/auto-complete/auto-complete";
import type { TagGroup } from "../../../../merge-tag/components/types";
import type { EditorLinkData } from "../../plugins/toolbar/hooks/use-link-button-on-click";
import type { Link } from "./types";

export const LinkTextField: FC<{
  filterTags: (x: string) => TagGroup;
  data: Pick<EditorLinkData, "mode" | "type">;
  disabled?: boolean;
}> = ({ filterTags, disabled, data: { mode, type } }) => {
  const {
    control,
    formState: { defaultValues, errors },
  } = useFormContext<Link>();

  if (mode !== "add" || !["range", "asset"].includes(type)) return null;

  return (
    <Controller
      name="text"
      control={control}
      render={({ field }) => (
        <AutoCompleteSelector
          defaultValue={field.value ?? defaultValues?.text ?? ""}
          onChange={field.onChange}
          filterTags={filterTags}
          renderInput={(params: TextFieldProps) => (
            <TextField
              {...params}
              id="link-text"
              label="Link text"
              placeholder="Link text"
              error={Boolean(errors?.text?.message)}
              helperText={errors?.text?.message}
              disabled={disabled}
              fullWidth
            />
          )}
        />
      )}
    />
  );
};
